module.exports = __webpack_public_path__ + "img/image26.632a9bb0.png";